import { render, staticRenderFns } from "./customModal.vue?vue&type=template&id=1da3a9da&scoped=true"
import script from "./customModal.vue?vue&type=script&lang=js"
export * from "./customModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da3a9da",
  null
  
)

export default component.exports